import { render, staticRenderFns } from "./Bando31Fase9.vue?vue&type=template&id=5c421c6e&scoped=true"
import script from "./Bando31Fase9.vue?vue&type=script&lang=js"
export * from "./Bando31Fase9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c421c6e",
  null
  
)

export default component.exports